import useIndicator, { Indicator, updateIndicator } from '@shared/hooks/src/useIndicator'
import usePubNub, { Channels } from '@shared/hooks/src/usePubNub'
import { useMe } from '@shared/providers/src/MeProvider'

export default function useUnreviewedLabs(options = {}) {
  const me = useMe()
  const enabled = options.enabled ?? false

  const { data: unreviewedLabs } = useIndicator(Indicator.UnreviewedLabs, undefined, {
    select: (data) => data.count,
    ...options,
  })

  usePubNub(
    `user_${me.id}`,
    ({ action, attributes }) => {
      if (action === Channels.UnreviewedLabs) {
        updateIndicator(me.id, Indicator.UnreviewedLabs, undefined, { count: attributes.count })
      }
    },
    { enabled }
  )

  return unreviewedLabs
}
